import { Nickname_Schema } from "@/services/user/profile/schema";
import { Rating_Schema } from "@/services/user/rating/ratingSchema";
import { WholeNumber_Schema } from "@/utilities";
import { z } from "zod";

export const UserId_Schema = WholeNumber_Schema;
export const AvatarUrl_Schema = z.url().nullable();

export const UserPublicInfo_Schema = z.object({
  id: UserId_Schema,
  nickname: Nickname_Schema,
  avatarUrl: AvatarUrl_Schema,
  rating: Rating_Schema,
  ratingCount: WholeNumber_Schema,
  itemsCount: WholeNumber_Schema,
});
